.<template>
  <div>
    <Loader v-if="couponLoading" />
    <SnackBar />
  </div>
</template>

<script>
import { Q_CHECK_DISCOUNT_COUPON } from "@/graphql";

import Loader from "@/components/Custom/Loader";
import SnackBar from "@/components/Custom/SnackBar";

export default {
  name: "Coupon",
  components: { Loader, SnackBar },
  data() {
    return {
      coupon: null,
      vid: null,
      ref: null,
      couponLoading: false
    };
  },
  methods: {
    async validateCoupon() {
      this.couponLoading = true;

      try {
        const result = await this.$apollo.query({
          client: "localClient",
          query: Q_CHECK_DISCOUNT_COUPON,
          variables: {
            coupon: this.coupon
          }
        });

        if (!result.data.check_discount_coupon.success) {
          throw new Error("Invalid coupon");
        }

        const freeMonths = result.data.check_discount_coupon.coupon.free_months;
        const discountName = result.data.check_discount_coupon.coupon.name;
        const discountPrepend =
          result.data.check_discount_coupon.coupon.prepend;

        this.$cookies.set("coupon", this.coupon, "7d");
        this.$cookies.set("coupon_months", freeMonths, "7d");
        this.$cookies.set("coupon_prepend", discountPrepend, "7d");
        this.$cookies.set("discount_name", discountName, "7d");

        if (this.coupon === "KLOUTED") {
          window.clickmagick_cmc = {
            uid: "157588",
            hid: "112900509",
            cmc_project: "Artist Hub",
            cmc_goal: "a",
            vid_info: "on",
            cmc_vid: this.vid,
            cmc_ref: this.ref
          };
          const script = document.createElement("script");
          script.src = "//cdn.clkmc.com/cmc.js";
          document.head.appendChild(script);
        }
      } catch (error) {
        console.log(error);
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Invalid coupon"
        });
      }

      this.couponLoading = false;
      this.$router.push({ name: "Homepage" });
    }
  },
  mounted() {
    this.coupon = this.$route.params.coupon;
    this.vid = this.$route.query.cmc_vid;
    this.ref = this.$route.query.ref;
    this.validateCoupon();
  }
};
</script>

<style></style>
